import { request } from "@/request";

export interface SearchParams {
  keyword: string;
}

export enum SearchType {
  Address = 1,
  Transaction = 2,
  Entities = 3,
}

export interface SearchData {
  id: number;
  icon: string;
  name: string;
  type: SearchType;
  blockchain?: string;
}

export interface SearchHistoryParams {
  limit?: number;
}

export interface IHistoryItem {
  id: number;
  objectId: string;
}

export function SearchHistory(params: SearchHistoryParams = {}) {
  return new Promise<Array<IHistoryItem>>(async (resolve) => {
    try {
      const limit = params.limit || 10;
      const r = await request.get<any>(`/scoring-analysis-history`, { limit });

      const items = r?.list || [];

      if (!Array.isArray(items)) {
        resolve([]);
        return;
      }

      resolve(items);
    } catch (ex) {
      console.log(ex);
      resolve([]);
    }
  });
}

export function DeleteSearchHistory(id: number) {
  return request.delete<any>(`/scoring-analysis-history/${id}`);
}

export function Search(params: SearchParams) {
  return new Promise<Array<SearchData>>(async (resolve, reject) => {
    const result: Array<SearchData> = [];

    try {
      const r = await request.get<any>(
        `/v1/search?q=${params.keyword}&offset=0&limit=10`,
      );

      r.addresses.items.forEach((i: any) => {
        result.push({
          id: 0,
          icon: ``,
          name: i.hash,
          blockchain: i.blockchain,
          type: SearchType.Address,
        });
      });

      r.transactions.items.forEach((i: any) => {
        result.push({
          id: 0,
          icon: ``,
          name: i.hash,
          blockchain: i.blockchain,
          type: SearchType.Transaction,
        });
      });

      r.entities.items.forEach((i: any) => {
        result.push({
          id: i.id,
          icon: "",
          name: i.name,
          type: SearchType.Entities,
        });
      });
    } catch (ex) {
      console.log(ex);
    }

    resolve(result);
  });
}
